export function linemeter(ctx) {
    return {
        // tick_color is read directly as node.theme.tick_color by
        // HaspLineMeter.js (bare, not through config/defaults merging or the
        // Style API — see linemeter.js's schema comment) — keep it bare here.
        tick_color: '#888888',
        properties: {
            value_color: '#ffffff',
            value_font:  32,
        },
        styles: {
            main: {
                ...ctx.pretty,
                radius: 999,
                line_color: '#ffffff',
                scale_grad_color: '#ffffff',
            },
        },
    };
}
